import { useEffect, useRef } from 'react';

import cartItemsSelectors from '../../../../cart/selectors/cartItemsSelectors';
import type { AsyncDispatcher } from '../../../hooks/useAsyncDispatcher';
import { useAppSelector } from '../../../hooks/useThunkDispatch';
import { storeSelectors } from '../../../selectors/storeSelectors';
import type { CartRecipe } from '../../../store/structureDefinitions/cartState';
import { ga4CartTracking } from '../../../tracking/ga4/cart';

export const useRecipeTracking = (
    removeRecipeDispatcher: AsyncDispatcher<void, []>,
    cartRecipe: CartRecipe | undefined,
) => {
    const currentCartItems = useAppSelector(cartItemsSelectors.selectAllCartItems);
    const previousCartItems = useRef(currentCartItems);
    const currentProductionUnit = useAppSelector(storeSelectors.currentProductionUnit);

    useEffect(() => {
        if (cartRecipe) {
            previousCartItems.current = currentCartItems;
        }
    }, [currentCartItems, cartRecipe]);

    const { status, reset } = removeRecipeDispatcher;
    useEffect(() => {
        if (status === 'success') {
            ga4CartTracking.changeCartItems(
                previousCartItems.current.map((item) => ({
                    productId: item.cartItemData.productId,
                    variantId: item.cartItemData.variantId,
                    quantity: item.cartItemData.quantity,
                })),
                currentCartItems.map((item) => ({
                    productId: item.cartItemData.productId,
                    variantId: item.cartItemData.variantId,
                    quantity: item.cartItemData.quantity,
                })),
                currentProductionUnit,
                {
                    list: 'BuyRecipeButton',
                    position: 0,
                },
            );

            reset();
        }
    }, [status, currentCartItems, currentProductionUnit, reset]);
};
